import React from 'react';
import { PropTypes } from 'prop-types';
import { withStyles } from '@mui/styles';

// Shared note for the Trends tab (provider + organization detail pages):
// sits top-right below the tabs, above the first card — mirrors the
// placement of ClaimsDateProvider on the other claims tabs.
const styles = (theme) => ({
  note: {
    marginLeft: 'auto',
    fontSize: 13,
    fontFamily: 'Roboto',
    textAlign: 'right',
    color: '#666666',
    paddingBottom: theme.spacing(2),
  },
});

function TrendsDateNote({ classes }) {
  return (
    <div className={classes.note}>
      Each quarter reflects the trailing 12 months
    </div>
  );
}

TrendsDateNote.propTypes = {
  classes: PropTypes.object.isRequired,
};

const Styled = withStyles(styles)(TrendsDateNote);
export { Styled as TrendsDateNote };
